var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAgeRating12 = function SvgAgeRating12(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2497 0C19.7686 0 21 1.23137 21 2.75034V18.2497C21 19.7686 19.7686 21 18.2497 21H2.75034C1.23137 21 0 19.7686 0 18.2497V2.75034C0 1.23137 1.23137 0 2.75034 0H18.2497Z",
    fill: "#D0D154"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5129 14.744L17.2889 16.36H9.84889V14.936C10.6596 14.2213 11.4089 13.584 12.0969 13.024C12.7849 12.464 13.3769 11.936 13.8729 11.44C14.3689 10.944 14.7582 10.4587 15.0409 9.984C15.3236 9.50933 15.4649 8.98933 15.4649 8.424C15.4649 7.85867 15.3076 7.41333 14.9929 7.088C14.6782 6.76267 14.2489 6.6 13.7049 6.6C13.0436 6.6 12.5476 6.74133 12.2169 7.024C11.8862 7.30667 11.6409 7.784 11.4809 8.456L9.73689 8.216C9.83289 7.78933 9.96889 7.38133 10.1449 6.992C10.3209 6.60267 10.5662 6.26133 10.8809 5.968C11.1956 5.67467 11.5849 5.44 12.0489 5.264C12.5129 5.088 13.0756 5 13.7369 5C14.9209 5 15.8222 5.30133 16.4409 5.904C17.0596 6.50667 17.3689 7.30933 17.3689 8.312C17.3689 8.94133 17.2542 9.504 17.0249 10C16.7956 10.496 16.4702 10.984 16.0489 11.464C15.6276 11.944 15.1209 12.4427 14.5289 12.96C13.9369 13.4773 13.2729 14.072 12.5369 14.744H17.5129ZM8.024 5.304V16.36H6.168V7.368L3.8 8.792L3 7.448L6.424 5.304H8.024Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgeRating12, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/age_rating_12.ae3b8d06.svg";
export { ForwardRef as ReactComponent };